import * as React from 'react';
import { useRef} from 'react'
import { black, fontBrand, gold, TypographyBrand, white} from '../../../../getLPTheme';
import 'react-multi-carousel/lib/styles.css';
import {Card, CardActionArea, Input, Stack, Typography} from "@mui/material";
import Container from '@mui/material/Container';
import { Box} from "@mui/material";
import MapInit from '../../../admin-view/components/map/mapInitContent';
import Map from '../../../../auxiliares/map/mapContent'

export interface positionProps {
  id: string;
  position: string;
}

//-------------------- Funcion principal exportada --------------------


export default function GestionarClubes () {

  const valueRef = useRef('') //creating a refernce for TextField Component

  const sendValue = () => {
      return console.log(valueRef.current.valueOf) //on clicking button accesing current value of TextField and outputing it to console 
  }

  return (
    <Box>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 1, sm: 3 },
        }}
      >
        <Box sx={{ width: { xs: '100%', sm: '70%' }, display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
          <Box  sx={{ width:{xs:"80%", sm:"50%", md:"70%"}, display: "flex",  flexDirection: 'column', alignItems: "Center", justifyContent: "center" }}>
            <Box sx={{width:"100%",pt:1}}>
              <TypographyBrand variant="body2" textAlign="center" fontFamily={fontBrand.principal} sx={{color: white[50], fontSize: {xs: '5vw', sm:'2vw'},}}>
                Buscar Clubes y Beneficios
              </TypographyBrand>
            </Box>
            <Box sx={{width:"100%",p:1, background: gold[500], mb: 2}}>
              <Input id="place-input" sx={{width:"100%",color: white[50], borderRadius:2}}/>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box sx={{display: {xs: "none", md: "flex", sm:"flex"},  alignItems: "center", justifyContent: "center", direction: "row",  }}>
            <Card sx={{p:1, backgroundColor: black[1000], transition: "0.2s","&:hover": {transform: "scale(1.02)"}}}>
                <Map ubication={'-35.0277990760964, -58.462617900285196'} height='600px' width='1000px' zoom={13} />
            </Card>
          </Box>
          <Box sx={{display: {xs: "flex", md: "none", sm:"none"}, width:{xs: 320, sm:820}, alignItems: "center", justifyContent: "center", direction: "row",  }}>
            <Card sx={{p:1, backgroundColor: black[1000], transition: "0.2s","&:hover": {transform: "scale(1.02)"}}}>
                <Map ubication={'-35.0277990760964, -58.462617900285196'} height='700px' width='300px' zoom={13} />
            </Card>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}